import routerOptions0 from "/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}